var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4995 15.9887V13.7306C17.5087 13.3614 17.3816 13.0017 17.1424 12.72C16.4679 11.9255 14.1545 11.4173 13.2375 11.6125C12.5228 11.7647 12.0226 12.4823 11.5337 12.9703C9.64553 11.8987 8.08215 10.3385 7.0085 8.454C7.49741 7.96607 8.21656 7.46697 8.36903 6.75357C8.56428 5.83981 8.05677 3.54124 7.26776 2.86403C6.99024 2.62583 6.63539 2.49647 6.26937 2.50007H4.00675C3.14465 2.50088 2.4274 3.27412 2.50589 4.14099C2.5 11.6125 8.33336 17.5 15.8554 17.4941C16.7269 17.5727 17.503 16.8519 17.4995 15.9887Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.22c010c8412babf21946729e104f107c.svg";
export { ForwardRef as ReactComponent };